<template>
  <div>
    <header-top></header-top>
    <div :style="{ width: templateWidth + 'px' }" class="recommend-img-wrap">
      <div v-for="(item,index) in imgJson" :key="index" class="recommend-img-box">
        <div v-for="(itm,idx) in item.imgArr" :key="idx" :style="{width: (100 / item.imgArr.length) + '%'}">
          <img v-if="itm.jumpType == '1'" :src="itm.imgSrc" alt="" class="recommend-img">

          <router-link v-if="itm.jumpType == '2'" tag="a" target="_blank" :to="{ name: 'Detail', query: { goodsId: itm.goodsId } }">
            <img :src="itm.imgSrc" alt="" class="recommend-img">
          </router-link>

          <a v-if="itm.jumpType == '3'" :href="itm.href" target="_blank">
            <img :src="itm.imgSrc" alt="" class="recommend-img">
          </a>
        </div>
      </div>
    </div>

    <div v-if="showModel == '2'" class="category-goods-wrap main-width recommend-wrap">
              <ul class="category-goods-list">
                <li
                  class="category-goods-item"
                  v-for="(item, index) in goodsObj.goodsList"
                  :key="index"
                >
                  <div class="category-goods-image">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{ name: 'Detail', query: { goodsId: item.appGoodsVo.goodsId } }"
                    >
                      <!-- <img
                        :src="imgAddress + item.appGoodsVo.goodsImage"
                        @error="error(1)"
                      /> -->
                      <div class="recommend-image" :style="{ backgroundImage: 'url(' + imgAddress + item.appGoodsVo.goodsImage + ')' }"></div>
                      <div
                        class="category-cover-image"
                        :class="{ a: item.appGoodsVo.isBill == 1 }"
                      ></div>
                      <div class="category-hover-product">
                        <table border="0" cellspacing="0" cellpadding="0">
                          <thead>
                            <tr>
                              <th>SKU</th>
                              <th>
                                <span v-if="item.appGoodsVo.isBill == 0">
                                  不带票结算价
                                  <span v-if="item.appGoodsVo.supplyChannel == 1"
                                    >(+运费)</span
                                  >
                                </span>
                                <span v-else>
                                  带票结算价
                                  <span v-if="item.appGoodsVo.supplyChannel == 1"
                                    >(+运费)</span
                                  >
                                </span>
                              </th>
                              <th>库存</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(itm, idx) in item.appGoodsVo.products"
                              v-if="idx < 7"
                              :key="idx"
                            >
                              <td class="category-table-SKU">
                                <div>{{ itm.specName }}</div>
                              </td>
                              <td>
                                <span v-if="item.appGoodsVo.isBill == 0">
                                  {{ itm.settlementPrice / 100 }}
                                  <span
                                    class="freight-price"
                                    v-if="item.appGoodsVo.supplyChannel == 1"
                                    >(+{{ itm.freight / 100 }})</span
                                  >
                                </span>
                                <span v-else>
                                  {{ itm.settlementPrice / 100 }}
                                  <span
                                    class="freight-price"
                                    v-if="item.appGoodsVo.supplyChannel == 1"
                                    >(+{{ itm.freight / 100 }})</span
                                  >
                                </span>
                              </td>
                              <td>
                                <span v-if="item.appGoodsVo.isBill == 0">{{
                                  itm.inventoryNum
                                }}</span>
                                <span v-else>{{ itm.inventoryNum }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </router-link>
                  </div>

                  <div class="category-goods-info">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      v-bind:content="item.appGoodsVo.goodsName"
                      placement="top"
                    >
                      <div class="category-goods-title2">
                        {{ item.appGoodsVo.goodsName }}
                      </div>
                    </el-tooltip>
                    <div class="category-goods-type">
                      <div
                        v-if="
                          item.appGoodsVo.supplyChannel == 2 || item.appGoodsVo.supplyChannel == 3
                        "
                      >
                        社群集采
                      </div>
                      <div v-if="item.appGoodsVo.supplyChannel == 1">一件代发</div>
                      <div
                        style="
                          background-color: rgb(231, 249, 235);
                          color: rgb(88, 191, 106);
                        "
                        v-if="item.appGoodsVo.isSelf == 1"
                      >
                        自产自销
                      </div>
                    </div>
                    <div class="category-goods-price2">
                      <div>
                        结算价
                        <span>
                          ¥
                          <span style="font-size: 18px">{{
                            item.appGoodsVo.originSettlementPrice / 100
                          }}</span>
                        </span>
                      </div>
                      <div>
                        毛利率 ¥
                        {{
                          (
                            ((item.appGoodsVo.salePrice - item.appGoodsVo.settlementPrice) /
                              item.appGoodsVo.salePrice) *
                            100
                          ).toFixed(2) + "%"
                        }}
                      </div>
                    </div>
                    <div class="category-goods-price3">
                      <div>建议零售价 ¥ {{ item.appGoodsVo.salePrice / 100 }}</div>
                      <div>
                        毛利 ¥
                        <span style="color: #ff6015">{{
                          (item.appGoodsVo.salePrice - item.appGoodsVo.settlementPrice).toFixed(2) /
                          100
                        }}</span>
                      </div>
                    </div>
                  </div>

              <el-row>
                  <el-col :span="12">
                    <div
                      v-if="item.appGoodsVo.shelves == 0"
                      class="category-goods-add-default"
                      @click="addNewShelves(item)"
                    >
                      加入货架
                    </div>
                    <div v-else class="category-goods-add-default yishangjia">
                      已加入货架
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-tooltip
                      v-if="true"
                      class="item"
                      effect="dark"
                      content="添加商品报价至报价篮子，可以批量导出商品报价"
                      placement="top"
                    >
                      <div @click="getPrice(index, item.appGoodsVo.goodsId)" class="get-price">获取报价</div>
                    </el-tooltip>
                    <el-tooltip
                      v-if="false"
                      class="item"
                      effect="dark"
                      content="该商品已添加至“报价篮子”，可以前往“报价篮子”导出报价！"
                      placement="top"
                    >
                      <div class="get-price yet">已添加报价</div>
                    </el-tooltip>
                  </el-col>
                </el-row>



                </li>
              </ul>

            </div>


            <el-dialog
    title=""
    :visible.sync="dialogVisible"
    width="600px">
    <div style="text-align: center">成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！</div>
    <span slot="footer" class="dialog-footer">
      <div class="category-goods-add-default" style="width: 200px;margin: 0 auto;" @click="dialogVisible = false" >我知道了</div>
    </span>
  </el-dialog>

  </div>
</template>
<script>
import headerTop from "../components/Header";
import store from "../store/index.js";
import {
  imgAddress,
  smallSerialDetail,
  smallSerialGoods,
  addGoodsAppReport,
  addNewShelves
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";

export default {
  data() {
    return {
      appId: store.state.appId,
      userId: store.state.userId,
      imgAddress: imgAddress,
      serialId: null,
      showModel: null,
      imgJson: null,
      templateWidth: null,
      goodsObj: null,
      dialogVisible: false,
    };
  },
  components: {
    headerTop
  },
  created() {
    this.serialId = this.$route.query.serialId;

  },
  mounted() {
    this.getSmallSerialDetail();
  },
  methods: {
    getSmallSerialDetail(){
      let url = smallSerialDetail;
      let _this = this;
      let params = {
        serialId: _this.serialId,
        userId: this.userId,
        appId: this.appId,
      };
      fetch(url, params).then(res => {
        if (res.code == 10000) {
          let data = res.data;
          _this.imgJson = JSON.parse(data.content);
          if(window.location.host.indexOf('localhost') == -1){
            _this.imgJson.forEach((item,index) => {
              item.imgArr.forEach((itm,idx) => {
                if(item.href){
                  item.href = item.href.replace('small.jioao.cn',window.location.host)
                }
              })
            })
          }
          _this.showModel = data.showModel;
          _this.templateWidth = data.templateWidth;
          // showModel == 2 展示商品
          if(data.showModel == 2){
            _this.getSmallSerialGoods()
          }
        }
      });
    },

    getSmallSerialGoods: function(){
      let data = {
        userId: this.userId,
        appId: this.appId,
        serialId: this.serialId,
      };
      let url = smallSerialGoods;
      fetch(url, data).then((res) => {
        if(res.code == 10000){
          this.goodsObj = res.data;
        }
      });
    },
    addNewShelves(row){
      let goodsList = [];
      row.appGoodsVo.products.forEach((item,index) => {
        let obj = {};
        obj.productId = item.productId;
        obj.goodsId = row.appGoodsVo.goodsId;
        obj.hasTax = row.appGoodsVo.isBill;
        //社群集采2 一件代发1
        if (
          row.appGoodsVo.supplyChannel == 2 ||
          row.appGoodsVo.supplyChannel == 3
        ) {
          obj.appType = 2;
        } else {
          obj.appType = 1;
        }
        goodsList.push(obj);
      })
      let params = {
        goodsList: goodsList,
        userId: this.userId,
      };
      fetch(addNewShelves, params).then(res => {
        if(res.code = 10000){
          toast('加入成功', 1, false);
          this.getSmallSerialGoods();
        }else{
          toast('加入失败', 2, false);
        }
      });
    },

    getPrice(index, goodsId){
      let _this = this;
      var data = {
        goodsIdList: [goodsId],
        appId: this.appId,
      };
      fetch(addGoodsAppReport, data).then((res) => {
        // _this.dialogVisible = true;
        if(res.code == 10000){
          toast('已加入报价篮子', 1, false);
        }
      });
    },


  }
};
</script>
<style lang="less" scoped>
.recommend-img-wrap{
  margin: auto;
  margin-top: 168px;
  max-width: 1920px;
  margin-bottom: 20px;
}
.recommend-img{
  vertical-align: top;
  width: 100%;
  display: block;
}
.recommend-img-box{
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}


</style>
<style scoped>
.category-cover-image.a {
  background: url(../assets/img/hanshui.png) no-repeat top right/60px 60px;
}
.category-cover-image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: url(../assets/img/buhanshui.png) no-repeat top right/60px 60px;
}
.category-filter-condition-item2 {
  display: inline-block;
  height: 33px;
  width: 90px;
  font-size: 12px;
  line-height: 33px;
  color: #494949;
  background-image: url(../assets/img/jiage_weixuan.png);
  background-repeat: no-repeat;
  background-size: 8px;
  background-position: 68px center;
  border-right: 1px solid #f1f1f1;
  text-indent: 30px;
  cursor: pointer;
}
.category-filter-condition-item2.s1 {
  background-image: url(../assets/img/jiage_sheng.png);
}
.category-filter-condition-item2.s2 {
  background-image: url(../assets/img/jiage_jiang.png);
}

.category-goods-price2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.category-goods-price2 > div:nth-child(1) {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}

.category-goods-price2 > div:nth-child(1) > span {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(254, 169, 35, 1);
  line-height: 17px;
}
.category-goods-price2 > div:nth-child(2) {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.category-goods-price3 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  margin-top: 5px;
}
.category-goods-type {
  display: flex;
  flex-direction: row;
  margin: 6px 0;
}
.category-goods-type > div {
  width: 60px;
  height: 22px;
  background: rgba(255, 248, 249, 1);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 77, 94, 1);
  line-height: 17px;
}
.category-goods-title2 {
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  height: 38px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.recommend-image{
  width: 240px;
  height: 240px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.recommend-wrap .category-hover-product {
  display: none;
}
.recommend-wrap .category-goods-image:hover .category-hover-product {
  display: block;
}

.get-price {
  margin-left: 10px;
  margin-top: 10px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #fea923;
  color: #fea923;
  cursor: pointer;
  background-color: #fff5ea;
}
.get-price.yet{
    background-color: #c0c0c0;
    color: #fff;
    border: 1px solid #c0c0c0;
}
</style>




// WEBPACK FOOTER //
// Recommend.vue?1426f0a6